import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { triggerTransition } from '@uirouter/redux';
import { clearChildEventDetails } from '@/actions/event';
import { clearActiveReservationDetails } from '@/actions/reservation';
import { setCheckoutOverlay, setCurrentMonth } from '@/actions/ui';
import EventSummaryContainer from '../../../containers/EventSummaryContainer';
import { setEventTimes, setSelectedDate, setSelectedChildEvent } from '../../../views/series/actions/event-series';
import { reservationActive } from 'checkout/selectors/reservation';
import Translation from '@s/Translation';
import { TranslationContext } from '../../../config/Translations';
import { clearAlerts } from '../../../actions/ui';
import { deleteReservation } from '../../../actions/reservation';
import { isSeatedListing } from '../../../selectors/reserved-seating';
import { isDynamicListing } from '@b/checkout/selectors/dynamic-listing';

class InventoryHeaderContainer extends Component {
    render() {

        if (!!this.props.hide) {
            return null;
        }

        return(
          <TranslationContext.Consumer>
            {(translation) => (
              <Fragment>
                {this.props.headerImage && !this.props.isSeated && (
                  <div className="tickets__banner-image">
                    <TranslationContext.Consumer>
                      {({ t }) => (
                        <img
                          src={this.props.headerImage}
                          alt={this.props.headerImageAltText || t('checkout__get_tickets_for_event', {
                            eventName: this.props.eventName
                          })}
                        />
                      )}
                    </TranslationContext.Consumer>
                    <div className="header__right">
                        <button
                            onClick={() => this.onCancel(translation)}
                            className="button--secondary button--close"
                        >
                            <i className="icon-close" aria-hidden="true"></i><span className="sr-only"><Translation>{'checkout__close'}</Translation></span>
                        </button>
                    </div>
                  </div>
                )}
                <div className="tickets__header">
                    {(!this.props.headerImage || this.props.isSeated) && (
                      <div className="header__right">
                          <button
                              onClick={() => this.onCancel(translation)}
                              className="button--clear button--close ticket__hide-overlay"
                          >
                              <i className="icon-close" aria-hidden="true"></i><span className="sr-only"><Translation>{'checkout__close'}</Translation></span>
                          </button>
                      </div>
                    )}
                    <EventSummaryContainer />
                </div>
              </Fragment>
            )}
          </TranslationContext.Consumer>
        )
    }

    onCancel = (translation) => {
        if (!this.props.reservationActive || !this.props.isEmbed || this.props.isDynamic) {
          this.props.setCheckoutOverlay(false);
        }

        if (!this.props.isDynamic && this.props.isEmbed && this.props.reservationActive) {
          const confirmed = confirm(translation.t("checkout__close_cart_confirmation"));
          if (confirmed) {
            this.props.clearAlerts();
            this.props.deleteReservation();
            window.scrollTo(0, 0);
            this.props.setCheckoutOverlay(false);
          }
        }

        if (this.props.childEvent && this.props.soldItemsCount === 0) {
          this.props.clearChildEventDetails();
          //clear selected date and time
          this.props.setEventTimes([]);
          this.props.setSelectedChildEvent(null);
          this.props.setSelectedDate('');
          this.props.setCheckoutOverlay(false);
          //close modal
          this.props.setCurrentMonth(null);
          if (this.props.reservationActive) {
              this.props.clearActiveReservationDetails();
          }
        }
    };
}

const mapStateToProps = (state, props) => {
    return {
        headerImage: state.ui.uiConfig?.images?.checkoutHeader ?? '',
        headerImageAltText: state.ui.uiConfig?.images?.checkoutHeaderAltText ?? '',
        eventName: state.ui.listingConfig?.listings?.title ?? '',
        childEvent: (state.event.childEvent) ? state.event.childEvent : null,
        soldItemsCount: (state.reservation.items_count !== undefined) ? state.reservation.items_count : 0,
        reservationActive: reservationActive(state),
        isEmbed: !!state.ui.isEmbed,
        token: state.reservation.token,
        isSeated: isSeatedListing(state),
        isDynamic: isDynamicListing(state),
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        triggerTransition,
        clearChildEventDetails,
        clearActiveReservationDetails,
        setCheckoutOverlay,
        setSelectedDate,
        setEventTimes,
        setSelectedChildEvent,
        setCurrentMonth,
        clearAlerts,
        deleteReservation
    },
    dispatch);
}

InventoryHeaderContainer.propTypes = {
    triggerTransition: PropTypes.func,
    clearChildEventDetails: PropTypes.func,
    clearActiveReservationDetails: PropTypes.func,
    setCheckoutOverlay: PropTypes.func,
    hide: PropTypes.bool,
    isEmbed: PropTypes.bool,
    isSeated: PropTypes.bool,
    headerImage: PropTypes.string,
    token: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToProps)(InventoryHeaderContainer)
